import { render, staticRenderFns } from "./ProfileGeneral.vue?vue&type=template&id=561edc49"
import script from "./ProfileGeneral.vue?vue&type=script&lang=js"
export * from "./ProfileGeneral.vue?vue&type=script&lang=js"
import style0 from "./ProfileGeneral.vue?vue&type=style&index=0&id=561edc49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports